import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import $ from 'jquery'


const Header = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLogin,setIsLogin] = useState(()=>{
    var l = sessionStorage.getItem("login");
    return l ? true :false;
  })

  const stepCount = 3; // Number of steps
  const navigate = useNavigate()

  useEffect(()=>{
    window.$('.menu').slicknav({
      prependTo: ".mobile-nav",
      duration: 300,
      closeOnClick: true,
    });
    document.querySelector('.btn_my_appointment').addEventListener('click', function() {
      var appoitmentdetail = localStorage.getItem("appointment_detail_id");
      if(appoitmentdetail && isLogin){
        appoitmentdetail = JSON.parse(appoitmentdetail);
        navigate("/chat", { state: { appId: appoitmentdetail.appId } });
      }else{
        navigate("/myappointment");
        sessionStorage.clear();
      }
    });
    if(isLogin){
      document.querySelector('.btn_logout').addEventListener('click', function() {
        navigate("/myappointment");
        sessionStorage.clear();
      });
    }
  },[])

  const handleNext = async () => {

    if (currentStep < stepCount - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const myappointmentClick = () =>{
    var appoitmentdetail = localStorage.getItem("appointment_detail_id");
    if(appoitmentdetail && isLogin){
      appoitmentdetail = JSON.parse(appoitmentdetail);
      navigate("/chat", { state: { appId: appoitmentdetail.appId } });
    }else{
      navigate("/myappointment");
      sessionStorage.clear();
    }
  }

  const handleSubmit = async () => {
    // setLoading(true);
    // await new Promise((res) => setTimeout(res, 3000));
    // setLoading(false);
    $('#bookingModal').modal('close')
    setShowSuccess(true);
    Swal.fire({
      title: "Success!",
      text: "We will confirm  by an Text Message !",
      icon: "success"
    });
    navigate('')
  };

  const pdf1 = "/assets/pdf/PHQ-9 and GAD-7 Form Fillable.pdf"
  const pdf2 = "/assets/pdf/Preview intake questionnaire - WITCARE HEALTH.pdf"


  return (
    <>

      <header className="header">
        {/* Topbar */}
        <div className="topbar">
          <div className="container pr-0">
            <div className="row top-navbar">
              <div className="col-lg-6 col-md-5 col-12 single-footer">
                {/* Contact */}
                <ul className="top-link Social">
                  <li>
                    <a href="#">
                      <i className="icofont-facebook" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-google-plus" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-twitter" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-vimeo" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="icofont-pinterest" />
                    </a>
                  </li>
                </ul>
                {/* End Contact */}
              </div>
              <div className="col-lg-6 col-md-7 col-12 p-0">
                {/* Top Contact */}
                <ul className="top-contact">
                  <li>
                    <i className="fa fa-phone" />
                    +732 960 1899
                  </li>
                  <li>
                    <i className="fa fa-envelope" />
                    <a href="mailto:support@yourmail.com">
                      drchinala@witcare.health
                    </a>
                  </li>
                </ul>
                {/* End Top Contact */}
              </div>
            </div>
          </div>
        </div>
        {/* End Topbar */}
        {/* Header Inner */}
        <div className="header-inner">
          <div className="container">
            <div className="inner">
              <div className="row">
                <div className="col-lg-4  col-12">
                  {/* Start Logo */}
                  <div className="logo">
                    <Link to="">
                      <img src="/assets/img/icons/logomain.jpg" alt="#" />
                    </Link>
                  </div>
                  {/* End Logo */}
                  {/* Mobile Nav */}
                  <div className="mobile-nav" />
                  {/* End Mobile Nav */}
                </div>
                <div className="col-lg-8 col-12">
                  {/* Main Menu */}
                  <div className="main-menu">
                    <nav className="navigation">
                      <ul className="nav menu">
                        <li>
                          <a href="#about">About Us</a>
                        </li>
                        <li>
                          <a href="#services">Services </a>
                        </li>
                        {/*<li><a href="#testimonials">Testimonials</a></li>*/}
                        <li>
                          <a href="#contact">Contact Us</a>
                        </li>
                        <li className='header-underline'>
                        <Link to="/bookappointment" className=''>
                          {/* <button  style={{ all: "unset" }}> */}
                          <button   className="btn btn-md  btn_appointment">
                            Book Appointment
                          </button>
                          {/* </button> */}
                          </Link>
                        </li>
                        <li style={{padding:"4px 10px"}}>
                          {/* <Link to="/myappointment" > */}
                            <button onClick={myappointmentClick}  className="btn  btn-md btn_my_appointment ">
                              My Appointment
                            </button>
                          {/* </Link> */}
                        </li>
                        {isLogin && <li style={{padding:"4px 10px"}}>
                            <button onClick={()=>{navigate("/myappointment");sessionStorage.clear();}}  className="btn  btn-md btn_logout ">
                             Logout
                            </button>
                          {/* <Link to="/myappointment" > */}
                          {/* </Link> */}
                        </li>}
                      </ul>
                    </nav>
                  </div>
                  {/*/ End Main Menu */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*/ End Header Inner */}
      </header>







    </>


  )
}

export default Header